/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AidModelResultsResponseDto,
  ModeledAdjustmentActionDto,
  ModeledAdjustmentBatchRequest,
  ModeledAdjustmentBatchResponse,
  ModeledAdjustmentDto,
  ModeledAdjustmentGridDto,
  ModeledAdjustmentPreviewRequestDto,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns the nested admit/yield enrollment-adjustment grid (regime -> need-rank bucket -> academic rank row) for the analyst grid screen. Per-row PY ADMITS / ADMIT TARGET / PY YIELD / PROJ YIELD are derived from the model's Databricks dataset; admitMultiplier/yieldMultiplier reflect the persisted rows, defaulting to 1 when unconfigured.
 * @summary Get the modeled adjustment grid
 */
export const getModeledAdjustmentGrid = (
  oktaUserId: string,
  modelId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ModeledAdjustmentGridDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/adjustments/modeled`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetModeledAdjustmentGridQueryKey = (
  oktaUserId: string,
  modelId: number
) => {
  return [
    `/api/${oktaUserId}/aid-models/${modelId}/adjustments/modeled`,
  ] as const;
};

export const getGetModeledAdjustmentGridQueryOptions = <
  TData = Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetModeledAdjustmentGridQueryKey(oktaUserId, modelId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModeledAdjustmentGrid>>
  > = ({ signal }) =>
    getModeledAdjustmentGrid(oktaUserId, modelId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && modelId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModeledAdjustmentGridQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModeledAdjustmentGrid>>
>;
export type GetModeledAdjustmentGridQueryError = ErrorType<unknown>;

export function useGetModeledAdjustmentGrid<
  TData = Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
          TError,
          Awaited<ReturnType<typeof getModeledAdjustmentGrid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetModeledAdjustmentGrid<
  TData = Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
          TError,
          Awaited<ReturnType<typeof getModeledAdjustmentGrid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetModeledAdjustmentGrid<
  TData = Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the modeled adjustment grid
 */

export function useGetModeledAdjustmentGrid<
  TData = Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModeledAdjustmentGrid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetModeledAdjustmentGridQueryOptions(
    oktaUserId,
    modelId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Deprecated: use POST .../adjustments/modeled/batch instead, which also covers custom Admit Adjustment population CRUD and priority order in the same transaction. Applies a batch of SAVE (upsert) and RESET (delete) actions on the persisted modeled admit/yield enrollment adjustments for this model. Returns the full current persisted set after all actions are applied.
 * @deprecated
 * @summary Persist modeled adjustments (deprecated - use applyModeledAdjustmentBatch)
 */
export const saveModeledAdjustments = (
  oktaUserId: string,
  modelId: number,
  modeledAdjustmentActionDto: BodyType<ModeledAdjustmentActionDto[]>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ModeledAdjustmentDto[]>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/adjustments/modeled`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: modeledAdjustmentActionDto,
      signal,
    },
    options
  );
};

export const getSaveModeledAdjustmentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveModeledAdjustments>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<ModeledAdjustmentActionDto[]>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveModeledAdjustments>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<ModeledAdjustmentActionDto[]>;
  },
  TContext
> => {
  const mutationKey = ['saveModeledAdjustments'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveModeledAdjustments>>,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<ModeledAdjustmentActionDto[]>;
    }
  > = (props) => {
    const { oktaUserId, modelId, data } = props ?? {};

    return saveModeledAdjustments(oktaUserId, modelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveModeledAdjustmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveModeledAdjustments>>
>;
export type SaveModeledAdjustmentsMutationBody = BodyType<
  ModeledAdjustmentActionDto[]
>;
export type SaveModeledAdjustmentsMutationError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary Persist modeled adjustments (deprecated - use applyModeledAdjustmentBatch)
 */
export const useSaveModeledAdjustments = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveModeledAdjustments>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        data: BodyType<ModeledAdjustmentActionDto[]>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof saveModeledAdjustments>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<ModeledAdjustmentActionDto[]>;
  },
  TContext
> => {
  return useMutation(
    getSaveModeledAdjustmentsMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Computes and returns the recalculated Aid Results estimated (New Projected Model) band with the previewed admit/yield adjustment cells stacked on top of any persisted modeled adjustments for this model. The same natural key (regime, adjustment type, academic rank, bucket rank) replaces the persisted entry; a new key is appended. Additionally accepts custom Admit Adjustment population drafts/priority order/population-cell overrides (null means use the persisted populations/order as-is) so the recomputed band reflects unsaved population changes. This is a read-only computation - nothing is persisted.
 * @summary Preview modeled adjustments
 */
export const previewModeledAdjustments = (
  oktaUserId: string,
  modelId: number,
  modeledAdjustmentPreviewRequestDto: BodyType<ModeledAdjustmentPreviewRequestDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelResultsResponseDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/adjustments/modeled/preview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: modeledAdjustmentPreviewRequestDto,
      signal,
    },
    options
  );
};

export const getPreviewModeledAdjustmentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewModeledAdjustments>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<ModeledAdjustmentPreviewRequestDto>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewModeledAdjustments>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<ModeledAdjustmentPreviewRequestDto>;
  },
  TContext
> => {
  const mutationKey = ['previewModeledAdjustments'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewModeledAdjustments>>,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<ModeledAdjustmentPreviewRequestDto>;
    }
  > = (props) => {
    const { oktaUserId, modelId, data } = props ?? {};

    return previewModeledAdjustments(oktaUserId, modelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewModeledAdjustmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewModeledAdjustments>>
>;
export type PreviewModeledAdjustmentsMutationBody =
  BodyType<ModeledAdjustmentPreviewRequestDto>;
export type PreviewModeledAdjustmentsMutationError = ErrorType<unknown>;

/**
 * @summary Preview modeled adjustments
 */
export const usePreviewModeledAdjustments = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewModeledAdjustments>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        data: BodyType<ModeledAdjustmentPreviewRequestDto>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewModeledAdjustments>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<ModeledAdjustmentPreviewRequestDto>;
  },
  TContext
> => {
  return useMutation(
    getPreviewModeledAdjustmentsMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns the same nested admit/yield enrollment-adjustment grid as getModeledAdjustmentGrid, recomputed from the request's custom Admit Adjustment population drafts/priority order/population-cell overrides (null means use the persisted populations/order/multipliers as-is) and previewed regime cells stacked on persisted ones - powering the tab list, PY Admits/Target/Yield, and "not included" coverage while the page has unsaved population changes. This is a read-only computation - nothing is persisted.
 * @summary Preview the modeled adjustment grid
 */
export const previewModeledAdjustmentGrid = (
  oktaUserId: string,
  modelId: number,
  modeledAdjustmentPreviewRequestDto: BodyType<ModeledAdjustmentPreviewRequestDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ModeledAdjustmentGridDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/adjustments/modeled/grid-preview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: modeledAdjustmentPreviewRequestDto,
      signal,
    },
    options
  );
};

export const getPreviewModeledAdjustmentGridMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewModeledAdjustmentGrid>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<ModeledAdjustmentPreviewRequestDto>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewModeledAdjustmentGrid>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<ModeledAdjustmentPreviewRequestDto>;
  },
  TContext
> => {
  const mutationKey = ['previewModeledAdjustmentGrid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewModeledAdjustmentGrid>>,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<ModeledAdjustmentPreviewRequestDto>;
    }
  > = (props) => {
    const { oktaUserId, modelId, data } = props ?? {};

    return previewModeledAdjustmentGrid(
      oktaUserId,
      modelId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewModeledAdjustmentGridMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewModeledAdjustmentGrid>>
>;
export type PreviewModeledAdjustmentGridMutationBody =
  BodyType<ModeledAdjustmentPreviewRequestDto>;
export type PreviewModeledAdjustmentGridMutationError = ErrorType<unknown>;

/**
 * @summary Preview the modeled adjustment grid
 */
export const usePreviewModeledAdjustmentGrid = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewModeledAdjustmentGrid>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        data: BodyType<ModeledAdjustmentPreviewRequestDto>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewModeledAdjustmentGrid>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<ModeledAdjustmentPreviewRequestDto>;
  },
  TContext
> => {
  return useMutation(
    getPreviewModeledAdjustmentGridMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Applies custom Admit Adjustment population CRUD (create/update/delete), the population/regime waterfall priority order, regime cell actions (same SAVE/RESET vocabulary as the deprecated saveModeledAdjustments), and custom-population cell actions - all in one transaction. Returns the full current persisted state for the model, including newly created population ids keyed by their client-supplied clientKey.
 * @summary Apply a batch of modeled adjustments and custom population changes
 */
export const applyModeledAdjustmentBatch = (
  oktaUserId: string,
  modelId: number,
  modeledAdjustmentBatchRequest: BodyType<ModeledAdjustmentBatchRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ModeledAdjustmentBatchResponse>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/adjustments/modeled/batch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: modeledAdjustmentBatchRequest,
      signal,
    },
    options
  );
};

export const getApplyModeledAdjustmentBatchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyModeledAdjustmentBatch>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<ModeledAdjustmentBatchRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyModeledAdjustmentBatch>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<ModeledAdjustmentBatchRequest>;
  },
  TContext
> => {
  const mutationKey = ['applyModeledAdjustmentBatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyModeledAdjustmentBatch>>,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<ModeledAdjustmentBatchRequest>;
    }
  > = (props) => {
    const { oktaUserId, modelId, data } = props ?? {};

    return applyModeledAdjustmentBatch(
      oktaUserId,
      modelId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyModeledAdjustmentBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyModeledAdjustmentBatch>>
>;
export type ApplyModeledAdjustmentBatchMutationBody =
  BodyType<ModeledAdjustmentBatchRequest>;
export type ApplyModeledAdjustmentBatchMutationError = ErrorType<unknown>;

/**
 * @summary Apply a batch of modeled adjustments and custom population changes
 */
export const useApplyModeledAdjustmentBatch = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof applyModeledAdjustmentBatch>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        data: BodyType<ModeledAdjustmentBatchRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof applyModeledAdjustmentBatch>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<ModeledAdjustmentBatchRequest>;
  },
  TContext
> => {
  return useMutation(
    getApplyModeledAdjustmentBatchMutationOptions(options),
    queryClient
  );
};
